import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { selectIsLoading, selectState } from '../../core/store/profile/profile.selectors';
import * as fromSportCenterAction from '../../core/store/profile/profile.actions';
import { State } from '../../core/store/profile/profile.reducer';

import { CommonModule } from '@angular/common';
import { TranslationLibModule } from '@libs/translation';
import { CoreModule } from '../../core/core.module';

import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonSpinner, IonText, IonTitle, IonToolbar } from '@ionic/angular/standalone';

@Component({
    selector: 'crud-details-info',
    templateUrl: 'crud-details-info.component.html',
    styleUrls: ['crud-details-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    IonBackButton,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
    CommonModule,
    TranslationLibModule,
    CoreModule
  ]
})
export class CrudDetailsInfoComponent {
    private store = inject(Store);


    crudInfo$ = this.store.select(selectState);
    isLoading$ = this.store.select(selectIsLoading);
    profileState: State;

    constructor() {
      this.crudInfo$.pipe(take(1)).subscribe(sportCenterState => this.profileState = sportCenterState )
    }

    register() {
      const profile = {
        address: this.profileState.addressInfo,
        credential: this.profileState.userInfo,
        owner: this.profileState.ownerCenterInfo,
      }
      this.store.dispatch(fromSportCenterAction.registerProfile({ profileState: profile }));
    }
}
